import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AlertCircle, ArrowRight } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

/**
 * ProfileCompletionBanner — Bannière affichée pour les retailers dont le profil est incomplet.
 * 
 * S'affiche uniquement si:
 * - L'utilisateur est un retailer
 * - account_status === 'a_completer'
 * - La route courante n'est PAS /dashboard/profil (évite le doublon avec le bloc unifié de ProfilePage)
 */
const ProfileCompletionBanner = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();

  if (!user || user.role !== 'retailer' || user.account_status !== 'a_completer') {
    return null;
  }

  // Sur /dashboard/profil, le bloc unifié de ProfilePage remplace cette bannière
  if (pathname === '/dashboard/profil') {
    return null;
  }

  return (
    <div
      className="w-full border-b border-amber-200 bg-amber-50"
      data-testid="profile-completion-banner"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-start sm:items-center gap-3">
        <AlertCircle className="h-5 w-5 text-amber-600 shrink-0 mt-0.5 sm:mt-0" />
        <div className="flex-1 text-sm text-amber-800">
          <p>
            Profil incomplet — Vous pouvez naviguer sur la plateforme avec un accès limité.
            Complétez votre profil pour accéder aux conditions de distribution.
          </p>
        </div>
        <Link
          to="/dashboard/profil"
          className="shrink-0 inline-flex items-center gap-1.5 text-sm font-semibold text-amber-700 hover:text-amber-900 transition-colors whitespace-nowrap"
          data-testid="profile-completion-banner-link"
        >
          Mon compte
          <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
};

export default ProfileCompletionBanner;
